"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncStoreOpt = exports.useSyncStore = exports.syncStore = void 0;
const react_1 = require("react");
const syncStore = (value) => ({
    getSnapshot: () => value,
    subscribe: () => () => { },
});
exports.syncStore = syncStore;
const emptySyncStore = (0, exports.syncStore)(void 0);
const useSyncStore = (store) => (0, react_1.useSyncExternalStore)(store.subscribe, store.getSnapshot);
exports.useSyncStore = useSyncStore;
const useSyncStoreOpt = (store = emptySyncStore) => (0, react_1.useSyncExternalStore)(store.subscribe, store.getSnapshot);
exports.useSyncStoreOpt = useSyncStoreOpt;
